import { twMerge } from 'tailwind-merge';

/** Join class names, letting later Tailwind utilities override earlier ones. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return twMerge(parts.filter(Boolean).join(' '));
}
